/**
 * SUNBAY Nexus credentials in Super Admin — pure rules. WRITE-ONLY: the API
 * returns status ({set, environment, baseUrlHost, updatedAt, updatedBy}),
 * never a credential, and the form starts empty every time.
 * Vendor names are fine here (Super Admin only).
 */
export const DEFAULT_SUNBAY_URL = 'https://open.sunbay.us';
export const PAYMENT_PROCESSORS_PATH = '/pos-config/payment-processors';
export type SunbayEnv = 'sandbox' | 'production';

export interface SunbayCredForm { appId: string; apiKey: string; secretKey: string; webhookSecret: string; environment: SunbayEnv; baseUrl: string }
export const emptySunbayCreds = (): SunbayCredForm => ({ appId: '', apiKey: '', secretKey: '', webhookSecret: '', environment: 'sandbox', baseUrl: DEFAULT_SUNBAY_URL });

export function sunbayCredProblems(f: SunbayCredForm): Partial<Record<keyof SunbayCredForm, string>> {
  const out: Partial<Record<keyof SunbayCredForm, string>> = {};
  if (!f.appId.trim()) out.appId = 'Required';
  if (!f.apiKey) out.apiKey = 'Required';
  if (!f.secretKey) out.secretKey = 'Required';
  if (!f.webhookSecret) out.webhookSecret = 'Required';
  const u = f.baseUrl.trim();
  if (!u) out.baseUrl = 'Required';
  else if (!/^https:\/\/[^\s/]+/i.test(u)) out.baseUrl = 'Must start with https://';
  return out;
}

export function sunbayCredBody(f: SunbayCredForm, confirmHost = false) {
  return {
    appId: f.appId.trim(), apiKey: f.apiKey, secretKey: f.secretKey, webhookSecret: f.webhookSecret,
    baseUrl: f.baseUrl.trim(), environment: f.environment, ...(confirmHost ? { confirmHost: true } : {}),
  };
}

/** "Set · Sandbox" / "Missing". */
export function sunbayChip(st: any): { tone: 'ok' | 'off'; text: string } {
  if (!st?.set) return { tone: 'off', text: 'Missing' };
  return { tone: 'ok', text: `Set · ${st.environment === 'production' ? 'Production' : 'Sandbox'}` };
}

/** Status line text for the page: "Set · Sandbox · open.sunbay.us · updated <date> by <who>". */
export function sunbayStatusLine(st: any, fmt: (iso: string | null | undefined) => string): string {
  if (!st?.set) return 'Missing';
  const c = sunbayChip(st).text;
  return `${c} · ${st.baseUrlHost || '—'} · updated ${fmt(st.updatedAt)}${st.updatedBy ? ` by ${st.updatedBy}` : ''}`;
}

export const MERCHANT_ID_RE = /^M[A-Za-z0-9]{10}$/;
export const STORE_ID_RE = /^S[A-Za-z0-9]{10}$/;
export function merchantProblems(merchantId: string, storeId: string): { merchantId?: string; storeId?: string } {
  const out: { merchantId?: string; storeId?: string } = {};
  if (!MERCHANT_ID_RE.test(merchantId.trim())) out.merchantId = 'Merchant ID is M followed by 10 letters or digits';
  if (storeId.trim() && !STORE_ID_RE.test(storeId.trim())) out.storeId = 'Store ID is S followed by 10 letters or digits';
  return out;
}
